import {
  isAddToCart,
  isFullPlacedBid,
  isLatestBid,
  isNewAuctionStatus,
  isNewRewardPopup
} from "./dataValidators";

export function validateFullPlacedBid(response: unknown): response is {
  status: number;
  data: FullPlacedBid;
} {
  console.log(response);
  if (!response || !(typeof response === "object")) {
    return false;
  }
  console.log(response);
  if (!("data" in response) || !response.data) {
    console.log("Invalid data");
    return false;
  }

  if (!isFullPlacedBid(response.data)) {
    console.log("Invalid message");
    return false;
  }

  console.log("Valid response");

  return true;
}

export function validateNewBidsCount(response: unknown): response is {
  status: number;
  data: { bids: number };
} {
  if (!response || !(typeof response === "object")) {
    return false;
  }
  // console.log(response);

  if (
    !("data" in response) ||
    !response.data ||
    typeof response.data !== "object"
  ) {
    console.log("Invalid data");
    return false;
  }

  if (!("bids" in response.data) || typeof response.data.bids !== "number") {
    console.log("Invalid bids");
    return false;
  }

  // console.log("Valid response");

  return true;
}

export function validateNewAuctionStatus(response: unknown): response is {
  status: number;
  data: NewAuctionStatus;
} {
  console.log(response);
  if (!response || !(typeof response === "object")) {
    return false;
  }
  console.log(response);
  if (!("data" in response) || !response.data) {
    console.log("Invalid data");
    return false;
  }

  if (!isNewAuctionStatus(response.data)) {
    console.log("Invalid message");
    return false;
  }

  console.log("Valid response");

  return true;
}

// favorite-product
export function validateFavoriteProduct(response: unknown): response is {
  status: number;
  data: {
    favoriteProducts: number[];
  };
} {
  if (!response || !(typeof response === "object")) {
    return false;
  }
  if (
    !("data" in response) ||
    !response.data ||
    typeof response.data !== "object"
  ) {
    console.log("Invalid data");
    return false;
  }

  if (
    !("favoriteProducts" in response.data) ||
    !Array.isArray(response.data.favoriteProducts) ||
    !response.data.favoriteProducts.every((id) => typeof id === "number")
  ) {
    console.log("Invalid message");
    return false;
  }

  return true;
}

export function validateAddToCart(response: unknown): response is {
  status: number;
  data: { cartItems: CartItem[] };
} {
  console.log(response);
  if (!response || !(typeof response === "object")) {
    return false;
  }
  if (
    !("data" in response) ||
    !response.data ||
    typeof response.data !== "object"
  ) {
    console.log("Invalid data");
    return false;
  }

  if (!isAddToCart(response.data)) {
    console.log("Invalid message");
    return false;
  }

  console.log("Valid response");

  return true;
}

export function validateLatestBid(response: unknown): response is {
  status: number;
  data: NewBidPopup;
} {
  console.log(response);
  if (!response || !(typeof response === "object")) {
    return false;
  }
  if (
    !("data" in response) ||
    !response.data ||
    typeof response.data !== "object"
  ) {
    console.log("Invalid data");
    return false;
  }

  if (!isLatestBid(response.data)) {
    console.log("Invalid message");
    return false;
  }

  console.log("Valid response");

  return true;
}

export function validateNewReward(response: unknown): response is {
  status: number;
  data: { reward: NewRewardPopup };
} {
  console.log(response);
  if (!response || !(typeof response === "object")) {
    return false;
  }
  if (
    !("data" in response) ||
    !response.data ||
    typeof response.data !== "object"
  ) {
    console.log("Invalid data");
    return false;
  }

  if (!("reward" in response.data) || !isNewRewardPopup(response.data.reward)) {
    console.log("Invalid message");
    return false;
  }

  console.log("Valid response");

  return true;
}

export function validateWonAuction(response: unknown): response is {
  status: number;
  data: { auctionID: number };
} {
  if (!response || !(typeof response === "object")) {
    return false;
  }
  if (
    !("data" in response) ||
    !response.data ||
    typeof response.data !== "object"
  ) {
    console.log("Invalid data");
    return false;
  }

  if (
    !("auctionID" in response.data) ||
    typeof response.data.auctionID !== "number"
  ) {
    console.log("Invalid message");
    return false;
  }

  return true;
}

export function validateAIUserDataResponse(
  responseData: AiUserData
): ValidateUserDataResponse | null {
  if (!responseData || !(typeof responseData === "object")) {
    return null;
  }

  let message = "AI User Data Validation Error(s): ";

  if (
    !("uuid" in responseData) ||
    (responseData.uuid !== null && typeof responseData.uuid !== "string")
  ) {
    message += " Invalid uuid.";
  }

  if (
    !("timestamp" in responseData) ||
    typeof (responseData as { timestamp: number }).timestamp !== "number"
  ) {
    message += " Invalid timestamp";
  }

  if (
    !("nickname" in responseData) ||
    typeof (responseData as { nickname: string }).nickname !== "string"
  ) {
    message += " Invalid nickname";
  }

  if (
    !("bidsPlaced" in responseData) ||
    typeof (responseData as { bidsPlaced: number }).bidsPlaced !== "number"
  ) {
    message += " Invalid bidsPlaced";
  }

  if (
    !("referrals" in responseData) ||
    typeof (responseData as { referrals: number }).referrals !== "number"
  ) {
    message += " Invalid referrals";
  }

  if (
    !("bidsBought" in responseData) ||
    typeof (responseData as { bidsBought: boolean }).bidsBought !== "boolean"
  ) {
    message += " Invalid bidsBought";
  }

  if (message !== "AI User Data Validation Error(s): ") {
    console.error(message);
    return null;
  }

  return {
    uuid: (responseData as { uuid: string }).uuid,
    timestamp: (responseData as { timestamp: number }).timestamp,
    nickname: (responseData as { nickname: string }).nickname,
    bidsPlaced: (responseData as { bidsPlaced: number }).bidsPlaced,
    referrals: (responseData as { referrals: number }).referrals,
    bidsBought: (responseData as { bidsBought: boolean }).bidsBought
  };
}
